import { fetchQuery } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { MINUTES } from '@sequencehq/utils/dates'
import { apiQueryClient } from 'features/api/apiQueryClient'
import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import { DEFAULT_SETTINGS } from 'modules/Integrations/integrationsConfig/hubSpot/hubSpot.constants'
import { HubSpotConfig } from 'modules/Integrations/integrationsConfig/hubSpot/hubspot.integration.config'

export const hubSpotConfigurationLoader = async (): Promise<{
  data: HubSpotConfig | null
  error: IntegrationsPortErrors | null
}> => {
  let integrationResponse
  try {
    integrationResponse = await fetchQuery(
      apiQueryClient,
      dashboard20240730Client.getIntegration,
      'HubSpot',
      { staleTime: 1 * MINUTES }
    )
  } catch {
    return {
      data: null,
      error: IntegrationsPortErrors.Other
    }
  }

  const integration =
    integrationResponse?.service === 'HubSpot' ? integrationResponse : null
  const settings = integration?.settings ?? null

  return {
    data: {
      importCustomerWorkflow: integration?.enabled ?? false,
      customerImportStages: settings?.customerImportStages ?? [
        ...DEFAULT_SETTINGS.customerImportStages
      ],
      signedQuoteStage:
        settings?.signedQuoteStage ?? DEFAULT_SETTINGS.signedQuoteStage,
      pdfSyncOnSign: settings
        ? settings.pdfSyncOnSign === 'SYNC'
        : DEFAULT_SETTINGS.pdfSyncOnSign,
      dealAmountSync: settings
        ? settings.dealAmountSync === 'SYNC'
        : DEFAULT_SETTINGS.dealAmountSync,
      isV2Integration: integration?.integrationVersion === 'V2'
    },
    error: null
  }
}
